<template lang='slm'>
  #app
    nav.navbar.navbar-expand-sm.navbar-light.bg-light.fixed-top
      .container-fluid
        router-link.navbar-brand to='/'
          img width=30 src='~img/logo.png'
        button.navbar-toggler type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation"
          span.navbar-toggler-icon
        #navbarContent.collapse.navbar-collapse ref='navbarContent'
          .mr-auto
          ul.navbar-nav
            li.nav-item
              a.nav-link :href='givingsUrl' target='_blank' rel='noopener noreferrer' Пожертвовать
            li.nav-item
              router-link.nav-link to='/question' Задать вопрос
            li.nav-item
              a.nav-link href='http://opros.mlt.church' Результаты опроса
    audio-player ref='audioPlayer'
    router-view#main
    .section.copyright
      .container
        h4.font-weight-light
          | Copyright by
          a.font-weight-bold.ml-2 href='https://t.me/aliksend' target='_blank' rel='noopener noreferrer' Alik Send
</template>

<style lang="sass">
  @import './bootstrap.scss';
</style>

<style lang='stylus'>
html
body
  min-height 100vh

footer-height = 43px
header-height = 58px
#main
  min-height 'calc(100vh - %s)' % (footer-height + header-height)

body
  padding-top header-height
  margin 0
  font-family 'Montserrat', sans-serif
  font-weight 400
  background-color light-color

.navbar
  min-height header-height

.section
  position relative
  text-align center
  overflow hidden
  &.header
    padding-top 16px
    padding-bottom 16px
    :last-child
      margin-bottom 0

h2
  font-weight 800 !important
  font-size 1.5em !important

h3
  font-weight 300 !important
  font-size 1.17em !important

.font-weight-medium
  font-weight 500 !important

.font-weight-semi-bold
  font-weight 600 !important

.font-weight-extra-bold
  font-weight 800 !important

.my-btn
  display inline-block
  font-weight 700
  padding 18px 48px
  border 2px solid
  border-color inherit
  border-radius 11px

a
a:hover
  color inherit
  text-decoration none

.d-flex
  align-items center

.flex-grow
  flex-grow 1

.cursor-pointer
  cursor pointer

.section.copyright
  .container
    h4
      margin-bottom 0
      margin-top 0
      font-size 1rem
    height footer-height
    display flex
    align-items center
    color black

for color in ('white' white) ('black' black) ('light' light-color) ('dark' dark-color)
  .bg-{color[0]}
    background-color color[1]
  .color-{color[0]}
    color color[1]
</style>

<script>
import AudioPlayer from '@/components/AudioPlayer';

export default {
  name: 'App',
  data() {
    return {
      givingsUrl: 'https://my-payments.privatbank.ua/mypayments/customauth/identification/fp/static?staticToken=cc12703a90473c833b6757ad487b68d36tq4ljqc',
    };
  },
  components: { AudioPlayer },
  methods: {
    playAudio(options) {
      this.$refs.audioPlayer.playAudio(options);
    },
    pauseAudio() {
      this.$refs.audioPlayer.pause();
    },
    hideAudioPlayer() {
      this.$refs.audioPlayer.hide();
    },
  },
};
</script>
